import React, { Component } from 'react';
import type { Store } from 'redux';
import AppBase from '@atlassian/jira-app-base';
import AppStyle from '@atlassian/jira-common-components-app-style';
import { ReportErrors } from '@atlassian/jira-errors-handling';
import type { Props } from './model/types';
import rootEpic from './ops';
import { setBaseUrl } from './services';
import createStore from './state';
import { setAppProps } from './state/actions';
import type { State } from './state/types';
import View from './view';

// eslint-disable-next-line jira/react/no-class-components
export default class CreateComponentModal extends Component<Props> {
	static defaultProps = {
		projectDefaultAssignee: undefined,
		projectLead: undefined,
	};

	constructor(props: Props) {
		super(props);

		// @ts-expect-error - TS2554 - Expected 2-3 arguments, but got 1.
		this.store = createStore(rootEpic);
		this.initializeProps(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps: Props) {
		this.initializeProps(nextProps);
	}

	initializeProps(props: Props) {
		this.store.dispatch(setAppProps(props));
		setBaseUrl(props.baseUrl);
	}

	store: Store<State>;

	render() {
		return (
			<AppBase store={this.store}>
				<ReportErrors
					id="unhandled"
					packageName="jiraProjectDirectoriesComponents"
					teamName="morphinecake"
					sendToPrivacyUnsafeSplunk
				>
					<AppStyle>
						<View />
					</AppStyle>
				</ReportErrors>
			</AppBase>
		);
	}
}
